import React from "react";
import { ImportantDocs, RequireDocs } from "../../types/serviceDetail";

interface Props {
  requireDocs: RequireDocs;
  importantNotes: ImportantDocs;
  sectionTitle: string | null;
  line: string | null;
  isPage?: boolean;
}

const ServiceRequiredDoc: React.FC<Props> = ({
  requireDocs,
  importantNotes,
  sectionTitle,
  line,
  isPage = false,
}) => {  
  const renderTitle = (title: string | null) => title ? (
    React.createElement(isPage ? 'h3' : 'p', {
      className: "text-center font-16 text-black ff-semibold mb-4",
      dangerouslySetInnerHTML: { __html: title }
    })
  ) : null;

  const renderLine = (line: string | null) => line ? (
    <p className="font-12 text-grey ff-normal text-center" dangerouslySetInnerHTML={{ __html: line }} />
  ) : null;
  const renderDocs = (docs: Array<any>, type: string) => docs.length > 0 && (
    <div className={`p-3 layout-border rounded mt-3 ${type === 'important' ? 'bg-4 my-3' : ''}`}>
      {type === 'important' && <h3 className="font-14 ff-semibold text-noti mb-2">Important Note:</h3>}
      <ol className={`font-12 ${type === 'important' ? 'text-noti' : ''} px-3`}>
        {docs.map((doc, index) => (
          <li
            key={`${type}-doc-${index}`}
            className={`pb-${type === 'important' ? 3 : 1} ${type === 'important' ? 'ff-medium' : 'pb-md-3'}`}
            dangerouslySetInnerHTML={{ __html: doc.TagLine ?? doc ?? "" }}
          />
        ))}
      </ol>
    </div>
  );
  const renderFeaturedDocs = () => (
    <div className="d-flex align-items-center justify-content-center gap-2 py-3">
      {requireDocs.featureDocs.map((option, index) => (
        <div
          key={`featured-doc-${index}`}
          className="d-flex align-items-center justify-content-start gap-3 p-2 px-md-3 px-1 bg-2 rounded-pill"
        >
          {option.icon && (
            <img
              src={option.icon || "/path-to-default-image.png"}
              alt={option.shortName || "Default name"}
            />
          )}
          <p
            className="mb-0 font-12 font-sm-10 text-grey ff-semibold"
            dangerouslySetInnerHTML={{ __html: option.shortName ?? "" }}
          />
        </div>
      ))}
    </div>
  );

  return (
    <div className="applicable-main-wrap py-4">
      {renderTitle(sectionTitle)}
      {renderLine(line)}
      
      {renderFeaturedDocs()}

      {renderDocs(requireDocs.requiredDocs, 'regular')}
      {importantNotes?.insideDescription && renderDocs(importantNotes.insideDescription.split("---"), 'important')}
    </div>
  );
};

export default ServiceRequiredDoc;